import React, { FC } from "react";
import bannerWinter1404 from "../../assets/images/ZitelPromotion-1404.jpg";
import Grid from "ui-modules/components/Layout/Grid";
import GridCell from "ui-modules/components/Layout/Grid/GridCell";

const PROMOTION_BANNER_DISMISSED_KEY = "promotionBannerDismissed";

export { PROMOTION_BANNER_DISMISSED_KEY };

type BannerWinterProps = {
  type?: "mobile" | "desktop";
  onClose?: () => void;
};

const closeButtonStyle: React.CSSProperties = {
  position: "absolute",
  top: 8,
  right: 8,
  width: 28,
  height: 28,
  borderRadius: "25%",
  border: "1px solid #fff",
  background: "rgba(0,0,0,0.5)",
  color: "#fff",
  fontSize: 18,
  lineHeight: 1,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 8,
};

const BannerWinter: FC<BannerWinterProps> = ({ type, onClose }) => {
  if (type === "mobile") {
    return (
      <Grid>
        <GridCell>
          <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
            <img style={{ width: "100%", borderRadius: 10 }} src={bannerWinter1404} alt="تخفیف زمستانه" />
            {onClose && (
              <button type="button" onClick={onClose} style={closeButtonStyle} aria-label="بستن">
                ×
              </button>
            )}
          </div>
        </GridCell>
      </Grid>
    );
  }

  return (
    <div
      style={{
        width: "25%",
        position: "fixed",
        bottom: 0,
        left: 78,
        borderRadius: 10,
        zIndex: 7,
      }}
    >
      <img style={{ width: "100%", borderRadius: 10, display: "block" }} src={bannerWinter1404} alt="تخفیف زمستانه" />
      {onClose && (
        <button type="button" onClick={onClose} style={closeButtonStyle} aria-label="بستن">
          ×
        </button>
      )}
    </div>
  );
};

export default BannerWinter;
